import { useAtom } from 'jotai';
import { atom } from 'jotai';
import { PointWarningDialogType } from '@/interfaces/paid-management';

interface PointWarningDialogState {
  open: boolean;
  type: PointWarningDialogType | null;
  backToHome?: boolean;
}

const pointWarningDialogAtom = atom<PointWarningDialogState>({
  open: false,
  type: null,
  backToHome: false,
});

export const usePointWarningDialog = () => {
  const [state, setState] = useAtom(pointWarningDialogAtom);

  const openDialog = (type: PointWarningDialogType, backToHome = false) => {
    setState({
      open: true,
      type,
      backToHome,
    });
  };

  const closeDialog = () => {
    setState({
      open: false,
      type: null,
      backToHome: false,
    });
  };

  return {
    ...state,
    openDialog,
    closeDialog,
  };
};
